import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './header.css';
import { API } from '../API/api';

const Header = () => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);

  const handleSubmit = async () => {
    try {
      const refresh = localStorage.getItem('refreshToken');
      const response = await API.post('/api/token/refresh/', { refresh });

      localStorage.setItem('accessToken', response.data['access']);
      localStorage.setItem('refreshToken', response.data['refresh']);
      setAuthenticated(true);
    } catch (e) {
      console.error('Token refresh error:', e);
      setAuthenticated(false);
      navigate('/');
    }
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  return (
    <div className="container">
      <header className="navbar">
        <div className="brand">RENU VOTING</div>
        <nav className="nav-links">
          <a href="/">Home</a>
          {authenticated && (
            <>
              <a href="/running">Elections</a>
              <a href="/leaderboard">Leader Board</a>
            </>
          )}
          <a href="/guidelines">Guidelines</a>
        </nav>
        {!authenticated ? (
          <button className="signup-btn" onClick={() => navigate('/login')}>Login</button>
        ) : (
          <button className="signup-btn" onClick={() => {
            localStorage.clear();
            setAuthenticated(false);
            navigate('/');
          }}>
            Logout
          </button>
        )}
      </header>
    </div>
  );
};

export default Header;
